<template>
  <section></section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
import globals from '@/plugins/globals'
const signalrUrl = window.config ? window.config.signalrUrl : ''
export default {
  name: 'service-hub',
  data() {
    return {
      connection: null,
      signalRstatus: '',
      signalRerror: '',
      connectedInterval: 0
    }
  },
  mounted() {
    this.$eventBus.$on('push-message', this.pushMessage)
    this.$eventBus.$on('send-message', this.sendMessage)
    this.initSignalR()
  },
  computed: {
    ...mapGetters('auth', ['token', 'profile']),
    isShop() {
      let _is = false
      if ([1, 2, 15, 16, 17].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isCenter() {
      let _is = false
      if ([1, 2, 12, 14].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    ...mapActions('calibrates', ['setCalibrateCounts']),
    ...mapActions('chat', ['getChannels']),
    initSignalR() {
      try {
        // Initialize SignalR
        if (this.connection === null) {
          this.connection = new HubConnectionBuilder()
            .withUrl(signalrUrl)
            .withAutomaticReconnect([0, 3000, 5000, 10000, 15000, 30000, 60000])
            .configureLogging(LogLevel.Information)
            .build()
          // Listen to "sendMessage"
          this.connection.on('sendMessage', data => {
            // console.log('ServiceHub (sendMessage - incoming)', data)
            if (data) {
              if (globals.isJson(data)) {
                let msg = JSON.parse(data)
                if (msg.name) {
                  if (msg.name === 'ImportServices') {
                    this.$eventBus.$emit('import-services', msg.data)
                  }
                } else {
                  if (msg.message !== null) {
                    if (globals.isJson(msg.message)) {
                      msg.message = JSON.parse(msg.message)
                      if (msg.type === 'Counts') {
                        if (this.isCenter && msg.target === 'Center') {
                          this.setCalibrateCounts(msg)
                        } else if (this.isShop && msg.target === 'Shop') {
                          if (parseInt(msg.id) === parseInt(this.profile.firm)) {
                            this.setCalibrateCounts(msg)
                          }
                        }
                      } else if (msg.type === 'Chat') {
                        if (msg.event === 'Incoming') {
                          console.log('Incoming Chat', msg)
                          this.recycleChat(data)
                        }
                      } else if (msg.type === 'Status') {
                        if (parseInt(msg.id) === parseInt(this.profile.firm)) {
                          console.log('Status Change', msg)
                          if (this.isShop && msg.target === 'Shop') {
                          } else if (this.isCenter && msg.target === 'Center') {
                          }
                        }
                      }
                    } else if (msg.type === 'Chat') {
                      if (msg.event === 'Incoming') {
                        if (msg.id === this.profile.username) {
                          console.log('Incoming Chat', msg)
                          this.recycleChat(data)
                        }
                      }
                    }
                  }
                }
                // console.log('Received Message', msg)
              } else if (data.channel !== null) {
                if (data.event === 'Incoming') {
                  if (data.id === this.profile.username) {
                    this.recycleChat(data)
                  }
                }
              }
            }
          })
          // Start SignalR connection
          this.connection
            .start()
            .then(() => {
              console.log('Service Hub Started')
            })
            .catch(err => {
              console.error(err.toString())
            })
        }
      } catch (e) {
        console.error('Error: serviceHub > initSignalR', e)
      }
    },
    sendMessage(message) {
      console.log('ServiceHub: Send a Message', message)
      this.connection
        .invoke('sendMessage', JSON.stringify(message))
        .then(result => {
          console.log('serviceHub: Sent a Message')
        })
        .catch(err => {
          console.error(err.toString())
        })
    },
    pushMessage(message) {
      console.log('ServiceHub: Pushed a Message', message)
      this.connection
        .invoke('sendChatPush', JSON.stringify(message))
        .then(result => {
          console.log('serviceHub: Pushed a Message', result)
        })
        .catch(err => {
          console.error(err.toString())
        })
    },
    async recycleChat(data) {
      await this.getChannels()
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('push-message')
    this.$eventBus.$off('send-message')
    this.connection.stop().then(() => {
      this.connection = null
      console.log('Service Hub Stopped')
    })
  }
}
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/admin/service-hub.vue